import { all, call, getContext, put, takeEvery } from 'redux-saga/effects';

import * as api from '../../api/api';
import * as actions from './actions';
import { logout } from '../auth/actions';
import { ConfigActionTypes } from './types';
import { ISystemAndUniConfig } from 'types';

function* handleGetConfig(action: ReturnType<typeof actions.getConfigRecord>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired');
      return;
    }
    const config: Partial<ISystemAndUniConfig> = yield call(api.getConfig, idToken, action.payload.university);

    yield put(actions.getConfigRecordSuccess(config));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getConfigRecordFailure(err.stack!));
    } else {
      yield put(actions.getConfigRecordFailure('An unknown error occured.'));
    }
  }
}

function* handleGetNavigationUrls(action: ReturnType<typeof actions.getNavigationUrls>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired');
      return;
    }
    const urls: { apply?: string; casStudent?: string; casStaff?: string } = yield call(
      api.getNavigationUrls, 
      idToken, 
      action.payload.university
    );

    yield put(actions.getNavigationUrlsSuccess(urls));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getNavigationUrlsFailure(err.stack!));
    } else {
      yield put(actions.getNavigationUrlsFailure('An unknown error occured.'));
    }
  }
}

function* watchGetConfig() {
  yield takeEvery(ConfigActionTypes.GET_UNI_CONFIG, handleGetConfig);
}

function* watchGetNavigationUrls() {
  yield takeEvery(ConfigActionTypes.GET_NAVIGATION_URLS, handleGetNavigationUrls);
}

function* ConfigSaga() {
  yield all([watchGetConfig(), watchGetNavigationUrls()]);
}

export default ConfigSaga;
